var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91 0.25L0.25 6.91V9.0325L9.0325 0.25H6.91ZM12.6326 0.308594L0.310059 12.6311C0.377559 12.8861 0.512559 13.1186 0.692559 13.3061C0.880059 13.4861 1.11256 13.6211 1.36756 13.6886L13.6976 1.36609C13.5551 0.848594 13.1501 0.443594 12.6326 0.308594ZM0.25 1.75C0.25 0.925 0.925 0.25 1.75 0.25H3.25L0.25 3.25V1.75ZM12.25 13.75C12.6625 13.75 13.0375 13.585 13.3075 13.3075C13.585 13.0375 13.75 12.6625 13.75 12.25V10.75L10.75 13.75H12.25ZM7.09 13.75H4.9675L13.75 4.9675V7.09L7.09 13.75Z",
    fill: "#696F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiIcon);
export default __webpack_public_path__ + "static/media/hi_icon.62d3dd2a2776a19c64ea994f468795ed.svg";
export { ForwardRef as ReactComponent };